<template>
<div class="shopping-trolley-layout" :style="{height: off_height}">
    <div class="shopping-trolley">
        <div class="order-form-list" v-for="(item,index) in shopping_trolley_list">
            <van-swipe-cell class="">
                <van-checkbox v-model="item.is_check" label-disabled :name="item.id" @change="change_is_check(index)">
                    <div class="list-top list-cell">
                        <div class="school-img"><img :src="imgUrl + item.img"></div>
                        <div class="school-text">
                            <div>
                                <span style="color: #403A3A;">{{item.title}}</span>
                            </div>
                            <div>
                                <span style="color: #ADADAF;">规格：{{item.sku}}</span>
                                <span style="color: #ADADAF;"></span>
                            </div>
                            <div>
                                <span class="money-of-sum">￥{{item.price_yuan}}</span>
                                <van-stepper v-model="item.num" integer input-width="40px" button-size="20px" @change="change_stepper(item,index)"/>
                            </div>
                        </div>
                    </div>
                </van-checkbox>
                <template #right>
                    <van-button square text="删除" left-width="0.6rem" type="danger" class="delete-button" @click="del_commodity(index)"/>
                </template>
            </van-swipe-cell>
        </div>
    </div>
    <div class="bottom-pay-info">
        <div>
            <van-checkbox v-model="all_checked" @click="select_checked(all_checked)">{{language_cut.check}}</van-checkbox>
            <div class="money money-of-sum">{{language_cut.total}}：￥{{num_money}}</div>
        </div>
        <button class="pay-btn" @click="ok">
            {{language_cut.btn}}
            <span v-if="checkbox_list.length > 0">( {{checkbox_list.length}} )</span>
        </button>
    </div>
</div>
</template>

<script>
export default {
    data() { 
        return {
            imgUrl: this.$commonVariable.imgUrl,
            all_checked: false,
            checkbox_list: [],
            num_money: 0,
            off_height: 0,
            shopping_trolley_list: [],
            language_cut: {
                check: '',
                total: '',
                btn: '',
            },
        }
    },
    created(){ 
        this.shopping_trolley_list = JSON.parse(sessionStorage.shopping_trolley_list)
        this.shopping_trolley_list.forEach(item => {
            item.is_check = true
        })
        this.change_is_check()

        this.off_height = ((document.body.clientHeight / 100) - 50) + 'rem'
    },
    mounted(){
        let that = this
        window.addEventListener('scroll', function () {
            if(document.getElementById("q1").offsetHeight == 84){
                document.querySelector(".bottom-pay-info").style.bottom="1.5rem";
            }else {
                if(that.if_iphone()){
                    document.querySelector(".bottom-pay-info").style.bottom="0.8rem";
                }else{
                    document.querySelector(".bottom-pay-info").style.bottom="1rem";
                }
            }
        }); 
        if(this.if_iphone()){
            document.querySelector(".bottom-pay-info").style.bottom="0.8rem";
        }
        this.language_cut_fun()
    },
    methods: { 
        language_cut_fun(){     // 语言切换
            if(sessionStorage.language == 'en'){
                this.language_cut = {
                    check: 'all',
                    total: 'total',
                    btn: 'cast',
                }
            }else{
                this.language_cut = {
                    check: '全选',
                    total: '合计',
                    btn: '结算',
                }
            }
        },
        if_iphone(){
            if(/iphone/gi.test(window.navigator.userAgent)){
                /* iPhone X、iPhone XS */
                var x=(window.screen.width === 375 && window.screen.height === 812);
                /* iPhone XS Max 、iPhone XR */
                var xMax=(window.screen.width === 414 && window.screen.height === 896);
                if(x || xMax){
                    return true;
                }else{
                    return false;
                }
            }else{
                return false
            }
        },
        del_commodity(index){    // 删除商品
            let del_list = this.shopping_trolley_list.splice(index,1)
            this.sess_set(this.shopping_trolley_list)
        },
        ok(){
            let list = this.shopping_trolley_list
            let check_list = []
            this.checkbox_list = []
            list.forEach(item => {     // 将is_check添加到数组中
                check_list.push(item.is_check)
                if(item.is_check == true){      // 复选框选择商品数组加一个字段，结算后边展示选择几个商品
                    this.checkbox_list.push('1')
                }
            })
            if (check_list.length >= 0 && check_list.indexOf(true) != -1) {      // 验证数组中是否有 false，没有则全选框为选中状态
                this.$router.push({
                    path: '/submit_order',
                    query: {
                        val: '购物车',
                    }
                })
            } else {
                this.$notify({ type: 'danger', message: '请选择商品之后点击结算' });
            }
        },
        // 全选和反选
        select_checked(bool) {
            let list = this.shopping_trolley_list
            if (bool) {
                list.forEach(item => {
                    item.is_check = true;
                    this.num_money += item.price
                    this.num_money = this.pub_fun.centToYuan(this.num_money)
                });
            } else {
                list.forEach(item => {
                    item.is_check = false;
                });
                this.num_money = '0.00'
            }
        },
        change_is_check(index){
            let list = this.shopping_trolley_list
            let check_list = []
            this.checkbox_list = []
            list.forEach(item => {     // 将is_check添加到数组中
                check_list.push(item.is_check)
                if(item.is_check == true){      // 复选框选择商品数组加一个字段，结算后边展示选择几个商品
                    this.checkbox_list.push('1')
                }
            })
            if (check_list.length <= 0 || check_list.indexOf(false) != -1) {      // 验证数组中是否有 false，没有则全选框为选中状态
                this.all_checked = false
            } else {
                this.all_checked = true
            }

            // 计算总金额
            let num = 0
            list.forEach(item => {
                if(item.is_check == true)
                num += item.price * item.num
            });
            this.num_money = num
            this.num_money = this.pub_fun.centToYuan(this.num_money)
            
            this.sess_set(list)
        },
        change_stepper(item,index){
            let num = 0
            let list = this.shopping_trolley_list
            list.forEach(item => {
                if(item.is_check == true)
                num += item.price * item.num
            });
            this.num_money = num
            this.num_money = this.pub_fun.centToYuan(this.num_money)
            this.shopping_trolley_list[index].num = item.num
            this.sess_set(this.shopping_trolley_list)
        },
        sess_set(list){
            sessionStorage.setItem('shopping_trolley_list',JSON.stringify(list))
        },
    },
}
</script>

<style lang="less">
    .shopping-trolley-layout{

        // .delete-button{
        //     width: 0.6rem;
        // }

        .van-button{
            height: 100%;
        }
        .van-button--square {
            width: 0.5rem;
            padding: 0 0.5rem;
        }

        .list-cell{
            padding: 0.2rem 0.4rem 0.2rem 0;
        }

        .shopping-trolley{
            box-sizing: border-box;
            font-size: 0.25rem;
            padding-bottom: 1rem;

            .order-form-list{
                margin-top: 0.2rem;
                background-color: #FFF;
                padding-left: 0.4rem;
                width: 100%;
                box-sizing: border-box;
            }
            
            .list-top{
                display: flex;

                .school-img{
                    margin-right: 0.3rem;

                    img{
                        width: 1.6rem;
                        height: 1.6rem;
                    }
                }

                .school-text{
                    width: 4rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    >div{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                }
            }
            
            .list-bottom{
                height: 0.7rem;
                box-sizing: border-box;
                line-height: 0.7rem;
                display: flex;
                justify-content: flex-end;
                color: #ADADAF;
                font-size: 0.2rem;
            }
        }

        .bottom-pay-info{
            position: fixed;
            bottom: 1rem;
            height: 1rem;
            width: 7.5rem;
            background-color: #FCFBFF;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.4rem;
            box-shadow:inset 0px -15px 10px -15px #b3afaf;
            visibility: visible;

            >div{
                display: flex;
                align-items: center;

                .van-checkbox__label{
                    padding-top: 0.05rem;
                    font-size: 0.2rem;
                    margin-left: 0.2rem;
                }

                >.money{
                    font-size: 0.3rem;
                    margin-left: 0.2rem;
                }
            }

            .pay-btn{
                font-size: 0.25rem;
                width: 2rem;
                height: 0.7rem;
                border-radius: 1rem;
                color: #FFF;
                background: linear-gradient(to right, #F08708 0%,#F9A908 100%);
            }

            .money-of-sum{
                color: #555454;
            }
        }

        .van-checkbox__label {
            margin-left: 0.35rem;
        }
    }
</style>